module.exports = __webpack_public_path__ + "components/flag/static/square/nf-388fb6be3390003a61e7ac8f39048ff3.svg";